import { moneyToMinor } from '@/utils/money';

/** Locale mapping for supported languages. */
const LOCALE_MAP: Record<string, string> = {
  zh: 'zh-CN',
  en: 'en-MY',
  ms: 'ms-MY',
};

const DEFAULT_LOCALE = 'en-MY';
const DEFAULT_CURRENCY = 'MYR';

/** Format display money while preserving exact cents for decimal strings. */
export function formatCurrency(
  amount: string | number,
  currency: string = DEFAULT_CURRENCY,
  lang: string = 'en',
): string {
  const locale = LOCALE_MAP[lang] ?? DEFAULT_LOCALE;
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (typeof amount === 'number') return formatter.format(amount);

  const minor = moneyToMinor(amount);
  if (minor == null) return amount;

  const negative = minor < 0n;
  const absolute = negative ? -minor : minor;
  const whole = absolute / 100n;
  const fraction = String(absolute % 100n).padStart(2, '0');
  const formatted = formatter
    .formatToParts(whole)
    .map((part) => (part.type === 'fraction' ? fraction : part.value))
    .join('');

  return negative ? `-${formatted}` : formatted;
}
